module.exports = __webpack_public_path__ + "img/Rogue-nightelf-m-70.f729ceca.gif";